import React from 'react';
import { NavLink } from 'react-router-dom';
import Icon from '../Icon';
import { signOut } from '../../Actions/Login.action';
import { translate } from '../../Services/translation';
import styled, { css } from 'styled-components';
import { fontFamilyBold, text } from '../../styling/mixins/typography';
import { getColor } from '../../styling/mixins/colors';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { showFor } from '../../styling/utils/visibility';

const StyledDesktopMenu = styled.div<{ showTrackingNumber: boolean }>`
  ${(props) => css`
    ${props.showTrackingNumber
      ? css`
          /* Styles for when showTrackingNumber is true */
          ${showFor('xlarge')}
        `
      : css`
          /* Styles for when showTrackingNumber is false */
          ${showFor('large')}
        `}
  `}

  .top {
    display: flex;
    flex-direction: column;
    margin-bottom: 1.2rem;
    text-transform: capitalize;
  }

  .overline {
    ${text('medium')}
    color: ${getColor('grey', 600)};
  }

  .item__wrapper {
    border: 1px solid ${getColor('grey', 300)};
    border-radius: 4px;
    overflow: hidden;
  }

  .sign-out {
    display: flex;
    align-items: center;

    &__icon {
      color: ${getColor('alert')};
      font-size: 2rem;
      margin-right: 0.8rem;
    }
  }
`;

const StyledMenuItem = styled.li`
  display: flex;
  border-bottom: 1px solid ${getColor('grey', 300)};
  background-color: ${getColor('white')};
`;

const StyledMenuAnchor = styled(NavLink)`
  ${text('medium')}
  padding: 1rem 1.2rem;
  flex: 1;

  &.active {
    background-color: ${getColor('grey', 100)};
    ${fontFamilyBold}
  }

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${getColor('grey', 100)};
  }
`;

const StyledSignOut = styled.li`
  display: flex;
  align-items: center;
  background-color: ${getColor('white')};
  ${text('medium')}
  padding: 1rem 1.2rem;
  flex: 1;
  cursor: pointer;

  &:hover {
    background-color: ${getColor('grey', 100)};
  }
`;

const MyPagesDesktopMenu = ({ navigation, showTrackingNumber }) => {
  const { current: userInfo } = useTypedSelector(
    (state) => state.userInfo
  );

  return (
    <StyledDesktopMenu showTrackingNumber={showTrackingNumber}>
      <div className="top">
        <span className="organization">
          {userInfo?.currentOrganizationName ??
            translate('mypage.site.title')}
        </span>
        <h5 className="name">
          {userInfo?.firstName} {userInfo?.lastName}
        </h5>
      </div>
      <ul className="item__wrapper">
        {navigation.map((option) => (
          <StyledMenuItem key={option.url + 'desktop'}>
            <StyledMenuAnchor to={option.url} end={option.url == '/'}>
              {option.name}
            </StyledMenuAnchor>
          </StyledMenuItem>
        ))}
        <StyledSignOut className="sign-out" onClick={signOut}>
          <Icon name="logout" className="sign-out__icon" />
          {translate('general.sign-out')}
        </StyledSignOut>
      </ul>
    </StyledDesktopMenu>
  );
};

export default MyPagesDesktopMenu;
